/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Add_Price_ChangedInputs */



/**
* | output |
* | --- |
* | "The price changed a moment ago – for example, someone else just took the free seat. Nobody was added and nothing was charged. Please check the new price and ..." |
*
* @param {Members_Add_Price_ChangedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_add_price_changed = /** @type {((inputs?: Members_Add_Price_ChangedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Add_Price_ChangedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Preis hat sich gerade geändert – zum Beispiel, weil jemand anderes den freien Platz belegt hat. Es wurde niemand hinzugefügt und nichts berechnet. Bitte prüfen Sie den neuen Preis und versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("The price changed a moment ago – for example, someone else just took the free seat. Nobody was added and nothing was charged. Please check the new price and try again.")
});